export default __webpack_public_path__ + "static/media/pin.3a42ed12.png";